import React from 'react';
import { Grid, Box, Typography, List, ListItem, Button } from '@mui/material';
import { AccordionComponent } from '../../components/Accordion/Accordion';
import { flexcol } from '../../global';

export const CalendarAccordions = () => {
  return (
    <Grid item sm={6} md={6} lg={12} style={flexcol}>
      <Box sx={{ mb: 2 }}>
        <AccordionComponent
          title='Scheduling information'
          summary={
            <Box sx={{ textAlign: 'left' }}>
              <Box sx={{ display: 'inline' }}>
                <Typography sx={{ display: 'inline' }}>
                  Your ETA colleagues schedule many virtual technical
                  assistance events across the agency. As such, the
                  OWI Technical Assistance Unit and Virtual Events
                  Team need adequate time to coordinate with each
                  individual staff person to ensure that each session
                  is "picture perfect." As you are deciding on dates
                  for your event, please plan accordingly, following
                  these business rules.
                </Typography>
              </Box>
              <List
                sx={{
                  listStyleType: 'disc',
                  pl: 4,
                  '& .MuiListItem-root': {
                    display: 'list-item'
                  }
                }}
              >
                <ListItem sx={{ display: 'list-item', paddingBottom: '0px' }}>
                  Live Events are not schedulable within 10 business
                  days from today's date.
                </ListItem>
                <ListItem sx={{ display: 'list-item', paddingBottom: '0px' }}>
                  Dry Runs are required.
                </ListItem>
                <ListItem sx={{ display: 'list-item', paddingBottom: '0px' }}>
                  If you are not able to select a date/time, that
                  means that date/time is not available.
                </ListItem>
              </List>
            </Box>
          }
          panel='panel1'
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <AccordionComponent
          title='How does it work?'
          summary={
            <Box sx={{ textAlign: 'left' }}>
              <Typography sx={{ display: 'inline' }}>
                The ETA TA Event Planner is designed to make
                the scheduling process easier and quicker for TA
                events hosted on WorkforceGPS. By scheduling a
                WorkforceGPS event with the Event Planner, you are able to
                submit a request to host a webinar or
                webcast on behalf of U.S. Department of Labor (DOL)
                Employment Training Administration (ETA). A submitted
                event request goes through a 3-part approval process
                that includes your program office and the Technical
                Assistance Unit (TAU). Once your event is submitted
                and you are logged into the Event Planner, you can review
                the status of your requested events on the homepage
                for both live events and dry runs. You will also
                receive email updates as your event goes through the
                approval chain. For any additional requests or
                questions regarding the Event Planner, contact{' '}
              </Typography>
              <Button
                variant='text'
                size='small'
                href={`mailto:events@workforcegps.org`}
                sx={{
                  textTransform: 'none',
                  paddingTop: '1px',
                  px: '0px',
                  color: '#006BD7',
                  ':hover': {
                    background: 'transparent'
                  }
                }}
              >
                <Typography sx={{ display: 'inline' }}>
                  events@workforcegps.org
                </Typography>
              </Button>
              <Typography sx={{ display: 'inline' }}>.</Typography>
            </Box>
          }
          panel='panel2'
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <AccordionComponent
          title='What if I do not have an account?'
          summary='To create your account for the first time please select "Sign Up" from the log in pop up. You will need to enter your full name, email address, and role. Once your request is submitted, your account will be reviewed and created within 1 business day. Once you sign up the first time, to plan your next TA event, you will simply enter your email address and password. Note: Your password will remain active until you change it.'
          panel='panel3'
        />
      </Box>
    </Grid>
  );
};

export default CalendarAccordions; 